module.exports = __webpack_public_path__ + "img/20171229_172741.f32fa5ad.jpg";